// @ts-strict-ignore
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';
import { ArticleVO } from '@article/model/vo/article.vo';
import { IArticleLocationProcessor } from '../processor/i-article-location.processor';
import { OnRailReferenceArticleLocationVO } from '../model/vo/on-rail-reference-article-location.vo';
import { AddArticleOnRailLocationProcessor } from '../processor/add-article-on-rail-location.processor';
import { RelativePositionReferenceArticleLocationVO } from '../model/vo/relative-position-reference-article-location.vo';
import { AddArticleToRelativeLocationProcessor } from '../processor/add-article-to-relative-location.processor';
import { ReplaceReferenceArticleLocationVO } from '@article/model/vo/replace-reference-article-location.vo';
import { ReplaceArticleOnRailLocationProcessor } from '../processor/replace-article-on-rail-location-processor';
import { SelectedConnectionsReferenceArticleLocationVO } from '@article/model/vo/selected-connections-reference-article-location.vo';
import { SelectedArticlesReferenceArticleLocationVO } from '@article/model/vo/selected-articles-reference-article-location.vo';
import { AddArticleToSelectedConnectionsLocationProcessor } from '../processor/add-article-to-selected-connections-location.processor';
import { CentreArticleLocationVO } from '../model/vo/centre-article-location.vo';
import { AddArticleInCentreProcessor } from '../processor/add-article-in-centre.processor';
import { ProjectModel } from '../../../model/project.model';
import { RemoveProjectArticleService } from '../../../service/remove-project-article.service';
import { ProjectMetaElementService } from '../../../manager/project-meta-element.service';
import { ArticleManager } from '@article/manager/article.manager';
import { ArticleInsertProcessorRegistry } from '../processor/prepare/insert/article-insert-processor-registry';
import { ProjectHelper } from '../../../helper/project.helper';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { InsertArticleHelperFactory } from '@article/helper/insert-article-helper.factory';
import { ReplaceLabelingArticleHelper } from '../../label/replace-labeling-helper/replace-labeling-article.helper';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { CompositeArticleUtils } from '@article/util/composite-article-utils';
import { ReplaceLabelingUtils } from '../../label/replace-labeling-helper/replace-labeling-utils';
import { InsertArticleUtils } from '../util/insert-article-utils';
import { ArticleAccessoryManager } from '@article/manager/article-accessory.manager';
import { PropertyCreator } from '@article/util/property-creator';
import { ArticleCreationManagerFactory } from '../manager/article-creation.manager.factory';
import { GenericArticleInsertProcessor } from '../processor/prepare/insert/generic-article-insert.processor';
import { DetachArticleUsageService } from '../../../service/detach-article-usage.service';
import { InsertArticleService } from './insert-article.service';
import { Injectable } from '@angular/core';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { AccessoryService } from '@article/service/accessory.service';
import { ReplaceBusbarService } from '@article/helper/replace/busbar/replace-busbar.service';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';
import { ReplaceBusbarArticleHelper } from '@article/helper/replace/busbar/replace-busbar-article.helper';

@Injectable({providedIn: 'root'})
export class InsertArticleServiceInitializer {

    constructor(
        private insertArticleService: InsertArticleService,
        private projectModel: ProjectModel,
        private removeProjectArticleService: RemoveProjectArticleService,
        private projectMetaElementService: ProjectMetaElementService,
        private articleManager: ArticleManager,
        private insertProcessorRegistry: ArticleInsertProcessorRegistry,
        private projectHelper: ProjectHelper,
        private localeResourceManager: LocaleResourceManager,
        private connectionInfoService: ConnectionInfoService,
        private insertArticleHelperFactory: InsertArticleHelperFactory,
        private replaceLabelingHelper: ReplaceLabelingArticleHelper,
        private containerService: ContainerService,
        private compositeArticleUtils: CompositeArticleUtils,
        private replaceLabelingUtils: ReplaceLabelingUtils,
        private insertArticleUtils: InsertArticleUtils,
        private articleAccessoryManager: ArticleAccessoryManager,
        private propertyCreator: PropertyCreator,
        private articleCreationManagerFactory: ArticleCreationManagerFactory,
        private insertProcessor: GenericArticleInsertProcessor,
        private applicationRefreshService: ApplicationRefreshService,
        private detachArticleUsageService: DetachArticleUsageService,
        private accessoryService: AccessoryService,
        private replaceBusbarService: ReplaceBusbarService,
        private replaceBusbarArticleHelper: ReplaceBusbarArticleHelper
    ) {

    }

    public initialize() {
        this.insertArticleService.initialize(this.createProcessor.bind(this));
    }

  private createProcessor(articleLocation: ArticleLocationVO, article: ArticleVO): IArticleLocationProcessor {
        if (articleLocation instanceof OnRailReferenceArticleLocationVO) {
            return new AddArticleOnRailLocationProcessor(
              articleLocation,
              article,
              this.projectModel,
              this.articleManager,
              this.insertProcessorRegistry,
              this.projectHelper,
              this.localeResourceManager,
              this.connectionInfoService,
              this.replaceBusbarArticleHelper,
              this.insertArticleHelperFactory,
              this.replaceLabelingHelper,
              this.containerService,
              this.replaceLabelingUtils,
              this.insertArticleUtils,
              this.replaceBusbarService
            );
        } else if (articleLocation instanceof RelativePositionReferenceArticleLocationVO) {
            return new AddArticleToRelativeLocationProcessor(
              articleLocation,
              article,
              this.insertProcessorRegistry,
              this.projectHelper,
              this.localeResourceManager,
              this.insertArticleHelperFactory,
              this.connectionInfoService,
              this.replaceBusbarArticleHelper,
              this.projectModel,
              this.projectMetaElementService,
              this.articleManager,
              this.articleAccessoryManager,
              this.replaceLabelingHelper,
              this.compositeArticleUtils,
              this.containerService,
              this.replaceLabelingUtils,
              this.insertArticleUtils,
              this.replaceBusbarService
            );
        } else if (articleLocation instanceof ReplaceReferenceArticleLocationVO) {
            return new ReplaceArticleOnRailLocationProcessor(
              articleLocation,
              article,
              this.insertProcessorRegistry,
              this.projectHelper,
              this.localeResourceManager,
              this.insertArticleHelperFactory,
              this.connectionInfoService,
              this.replaceBusbarArticleHelper,
              this.articleManager,
              this.projectModel,
              this.insertArticleUtils,
              this.containerService,
              this.applicationRefreshService,
              this.detachArticleUsageService,
              this.replaceBusbarService
            );
        } else if (
            articleLocation instanceof SelectedConnectionsReferenceArticleLocationVO ||
            articleLocation instanceof SelectedArticlesReferenceArticleLocationVO
        ) {
            return new AddArticleToSelectedConnectionsLocationProcessor(
              articleLocation,
              article,
              this.removeProjectArticleService,
              this.articleManager,
              this.localeResourceManager,
              this.propertyCreator,
              this.articleCreationManagerFactory,
              this.accessoryService
            );
        } else if (articleLocation instanceof CentreArticleLocationVO) {
            return new AddArticleInCentreProcessor(
                articleLocation,
                article,
                this.projectModel,
                this.articleManager,
                this.insertProcessorRegistry,
                this.replaceBusbarArticleHelper,
                this.projectHelper,
                this.localeResourceManager,
                this.connectionInfoService,
                this.insertArticleHelperFactory,
                this.insertProcessor,
                () => this.insertArticleService.markAllArticlesLoaded());
        } else {
            return null;
        }
    }

}
